import moment from "moment";

function uptimeSeries(data) {
  const labels = [];
  const values = [];

  data.forEach(point => {
    labels.unshift(moment.utc(point.date).format("MMM D"));
    values.unshift(point.percent_up);
  });

  return { labels, series: [values] };
}

function responseSeries(data) {
  return Array.from(data, point => ({
    x: new Date(point[0]),
    y: point[1]
  }));
}

export default class SiteApiResponse {
  constructor(responseText) {
    this.data = JSON.parse(responseText);
  }

  get name() {
    return this.data.name;
  }

  get state() {
    return this.data.state || "Unknown";
  }

  get averageResponseTime() {
    const ms = Math.round(
      this.response.hour.reduce((a, v) => a + v[1], 0.0) /
        this.response.hour.length
    );
    return `${ms}ms`;
  }

  get averageUptime() {
    return Math.round(
      this.uptime.day.reduce((a, v) => a + v.percent_up, 0.0) /
        this.uptime.day.length
    );
  }

  get lastChecked() {
    return this.data.last_checked_at
      ? moment(this.data.last_checked_at).calendar()
      : "Never";
  }

  get lastOutage() {
    const outage = this.data.outages[0];
    if (outage && outage.down_at && outage.up_at) {
      const down = moment(outage.down_at);
      const up = moment(outage.up_at);
      const duration = moment.duration(down.diff(up));
      return `<span class="big">${duration.humanize()}</span><br>${down.calendar()}`;
    }
    return '<span class="big">None</span>';
  }

  get uptime() {
    return this.data.uptime || {};
  }

  get response() {
    return this.data.response_times || {};
  }

  get uptimeByDaySeries() {
    return uptimeSeries(this.uptime.day);
  }

  get uptimeByMonthSeries() {
    return uptimeSeries(this.uptime.month);
  }

  get responseByDaySeries() {
    return responseSeries(this.response.day);
  }

  get responseByHourSeries() {
    return responseSeries(this.response.hour);
  }
}



// WEBPACK FOOTER //
// ./src/site_api_response.js